// 角色报工关联
<template>
  <div style="position: relative">
    <el-form
      ref="formSysPost"
      :model="formSysPost"
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-button
          slot="operator"
          type="primary"
          size="small"
          @click="addItem()"
        >
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <Table
          :tableData="tableData"
          :loading="false"
          :operateWidth="160"
          :tableHeader="tableHeader"
          :pagination="pagination"
          @pagination="changePagination"
          :slotArr="slotArr"
        >
          <!-- table 操作栏 -->
          <template slot="operation" slot-scope="scope">
            <el-button @click.stop="editItem(scope.row)" type="text">
              编辑
            </el-button>
            <el-button
              class="table-btn delete"
              @click.stop="deleteItem(scope.row)"
              type="text"
            >
              删除
            </el-button>
          </template>
        </Table>
      </el-col>
    </el-row>

    <el-dialog
      :title="title === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      @close="diaClose"
      width="360px"
      top="100px"
      class="dia_box"
    >
      <AddOrEdit
        v-if="dialogVisible"
        @diaClose="diaClose"
        @onAdd="onAdd"
        @onUpdate="onUpdate"
        :row="row"
      />
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import rules from "@/utils/validate.js";
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget,
} from "@/utils/widget.js";
import AddOrEdit from "./indexInfo.vue";
import Table from "../../components/MyTable/index.vue";
import {
  findItemFromList,
  findTreeNodePath,
  findTreeNodeObjectPath,
} from "@/utils";
export default {
  name: "LabelModel",
  props: {},
  components: {
    AddOrEdit,
    Table,
  },
  // mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      showSearch: true,
      slotArr: [
        { slotname: "headBox" },
        { slotname: "searchBox", className: "search_box" },
        { slotname: "btnBox", className: "" },
      ],

      tableData: [],

      tableHeader: [],
      // table 筛选条件
      tableParams: {},
      tableSearch: [],

      pagination: {
        size: 10,
        total: 0,
        page: 1,
      },

      formSysPost: {
        formFilter: {
          postName: undefined,
        },
        formFilterCopy: {
          postName: undefined,
        },
        sysPost: {
          impl: new TableWidget(
            this.loadSysPostWidgetData,
            this.loadSysPostVerify,
            true,
            false,
            "level",
            1
          ),
        },
        isInit: false,
      },

      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、编辑
      row: {},

      product_lineinfoArr: [
        { id: 1, name: "总装小线" },
        { id: 2, name: "总装中线" },
        { id: 3, name: "总装大线" },
      ],
    };
  },
  methods: {
    // 筛选 页数为 1
    onSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    // 页数切换
    changePagination(val) {
      this.pagination = {
        ...this.pagination,
        ...val,
      };
      this.getTableData();
    },
    async getTableData() {
      let params = {
        datasourceId: "1712669759671111680",
        pageParam: {
          pageNum: this.pagination.page,
          pageSize: this.pagination.size,
        },
        filterDtoList: [
          // {
          //   columnName: "batch_type",
          //   columnValue: "take_produce_cp",
          //   filterType: 1,
          //   tableName: "zz_test_product_order",
          // },
        ],
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listByDatasourceId/" + "roleReport",
        "post",
        params
      );
      httpCall.then((res) => {
        console.log("res.data", res.data);
        this.tableData = res.data.dataList;
        this.pagination.total = res.data.totalCount;
      });
    },
    addItem() {
      this.row = {};
      this.title = 1;
      this.dialogVisible = true;
    },
    onAdd(Obj) {
      let params = {
        datasourceId: "1712669759671111680",
        masterData: Obj.masterData,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/addDatasource/" + "roleReport",
        "post",
        params
      );
      httpCall.then((res) => {
        console.log("新增成功 res.data", res.data);
        this.dialogVisible = false;
        this.getTableData();
      });
    },
    onUpdate(Obj) {
      let params = {
        datasourceId: "1712669759671111680",
        masterData: Obj.masterData,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/updateDatasource/" + "roleReport",
        "post",
        params
      );
      httpCall.then((res) => {
        this.dialogVisible = false;
        this.getTableData();
      });
    },
    // 重置
    reset() {
      this.tableParams = {};
      this.getTableData();
    },
    diaClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.title = null;
      }, 100);
    },
    editItem(row) {
      this.row = row;
      this.title = 2;
      this.dialogVisible = true;
    },
    // 删除
    async onDel(row) {
      let params = {
        dataId: row.id,
        datasourceId: "1712669759671111680",
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/deleteDatasource/" + "roleReport",
        "post",
        params
      );
      httpCall.then((res) => {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getTableData();
      });
    },
    deleteItem(row) {
      this.$alert("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.onDel(row);
          }
        },
      });
    },

    // 获得字典值
    getDictValueArr(str) {
      let arr = str.split(",");
      let r = [];
      if (this.product_lineinfoArr && Array.isArray(this.product_lineinfoArr)) {
        arr.forEach((el) => {
          r.push(
            (findItemFromList(this.product_lineinfoArr, Number(el), "id") || {})
              .name
          );
        });
        return r.toString();
      }
      return str;
    },
  },
  mounted() {
    this.tableHeader = [
      { label: "序号", prop: "index" },
      {
        label: "生产车间",
        prop: "product_line",
        render: (h, params) => {
          return <p>{params.row.product_line__DictMap.name}</p>;
        },
      },
      {
        label: "生产总线",
        prop: "product_lineinfo",
        render: (h, params) => {
          return <p>{this.getDictValueArr(params.row.product_lineinfo)}</p>;
        },
      },
      {
        label: "工序",
        prop: "processes_id",
        render: (h, params) => {
          return <p>{params.row.processes_id__DictMap.name}</p>;
        },
      },
      {
        label: "角色",
        prop: "role_id",
        render: (h, params) => {
          return <p>{params.row.role_id__DictMap.name}</p>;
        },
      },
      { label: "操作", slotname: "operation", width: "120" },
    ];

    this.getTableData();
  },
  activated() {
    this.getTableData();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.dia_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.5);

  // ::v-deep {
  //   .el-dialog {
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
</style>
